import { UserAccountType } from "@common/constants";
import { UserAccount } from "@data-types";

export function isWalletDisabledForBetting(wallet: UserAccount): boolean {
	return (
		wallet.abrv == UserAccountType.SportBettingAccountShop ||
		(wallet.abrv == UserAccountType.SportBettingAccountShopOnline &&
			wallet.isBettingOnWebWithShopOnlineDisabled) ||
		!wallet.isOrgStructureActive ||
		wallet.isManuallyDisabled ||
		(wallet.abrv == UserAccountType.CashToDigitalAccount &&
			wallet.isRelatedUserLocked)
	);
}
